import { LitElement, css, html } from "lit";
import { customElement, property } from "lit/decorators.js";

/** "n green signals out of N" ring. Purely visual: the numbers come from the API. */
@customElement("ld-score-ring")
export class LdScoreRing extends LitElement {
  @property({ type: Number }) value = 0;
  @property({ type: Number }) total = 0;

  static styles = css`
    :host { display: block; }
    .ring {
      width: 128px; height: 128px; border-radius: 50%; position: relative;
      display: flex; align-items: center; justify-content: center; flex-direction: column;
    }
    .ring::before { content: ""; position: absolute; inset: 10px; border-radius: 50%; background: var(--white); }
    .value { position: relative; font-size: 26px; font-weight: 800; font-family: var(--font-mono); }
    .caption { position: relative; font-size: 11px; color: var(--slate-400); font-weight: 600; }
  `;

  render() {
    const ratio = this.total ? this.value / this.total : 0;
    const deg = Math.round(ratio * 360);
    const color = ratio === 1 ? "var(--green)" : ratio >= 0.6 ? "var(--amber)" : "var(--red)";
    return html`<div
      class="ring"
      style="background: conic-gradient(${color} 0deg ${deg}deg, var(--slate-200) ${deg}deg 360deg)"
      role="img"
      aria-label="${this.value} voyants verts sur ${this.total}"
    >
      <span class="value">${this.value}/${this.total}</span>
      <span class="caption">voyants verts</span>
    </div>`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "ld-score-ring": LdScoreRing;
  }
}
